import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';
import { get, set } from 'lodash';

export class NavigationSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'navigation');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [

            this.comboField('size', {
                'Hidden': 'hidden',
                'Auto': 'auto',
                'Compact': 'compact',
                'Expanded': 'expanded',
            }),
            this.comboField('position', {
                'Left': 'left',
                'Right': 'right',
            }),
            this.sizeNumberField('width', 'rem', 0, 40),
            this.sizeNumberField('padding'),
            this.toggleField('section.title.visible'),

            this.fontFamilyField('font.family', ['main', 'content', 'header']),
            this.sizeNumberField('font.size'),
            this.fontWeightField('font.weight', ['main', 'content']),
            this.fontColorComboField('font.color', ['main', 'content', 'header']),
            this.fontTransformField('font.transform'),
            this.fontColorComboField('muted.color', ['navigation', 'main', 'content'], {
                ...this.shadeValues('fade', 'navigation', 'font', [0.2, 0.35, 0.5, 0.65]),
                ...this.shadeValues('fade', 'main', 'font', [0.2, 0.35, 0.5, 0.65]),
                ...this.preset('muted-color', 'main'),
            }),

            this.fontColorComboField('icon.color', ['navigation', 'main', 'content'], { ...this.preset('icon-color', 'main'), [this.translateValue('INHERIT')]: 'inherit' }),

            this.backgroundColorField('background.color', ['main', 'content']),
            this.borderColorField('border.color', ['main', 'content']),
            this.sizeNumberField('border.width', 'px'),

            this.fontColorComboField('subnav.font.color', ['main', 'content', 'header']),
            this.backgroundColorField('subnav.background.color', ['main', 'content']),

            
            this.comboField('active.style', {
                'Background': 'background',
                'Left': 'left-border',
                'Right': 'right-border',
            }),
            this.fontColorComboField('active.font.color', ['main', 'content', 'header'], { ...this.preset('active-font-color', 'main'), 'Primary Contrast': 'var(--color-primary-contrast)' }),
            this.backgroundColorField('active.background.color', ['main', 'content'], { ...this.preset('active-background-color', 'main'), 'Primary': 'var(--color-primary-color)' }),
            this.sizeNumberField('active.border.radius', 'px'),
            this.sizeNumberField('active.margin.x'),
            
            this.fontColorComboField('hover.font.color', ['navigation', 'main', 'content', 'header'], this.preset('hover-font-color', 'main')),
            this.backgroundColorField('hover.background.color', ['navigation', 'main', 'content'], this.preset('hover-background-color', 'main')),

            this.sizeNumberField('separator.width', 'px'),

            this.backgroundColorField('logo.background.color', ['navigation', 'main', 'content']),
            this.borderColorField('logo.border.color', ['navigation', 'main', 'content']),
            this.sizeNumberField('logo.border.width', 'px'),
            this.sizeNumberField('logo.width', 'px', 0, 400),
            this.logoHeightField(),


        ];
    }

    // the shared size field cannot express 'auto', which is the default here — an unset height lets
    // the block size itself from the logo, as it always has
    logoHeightField(): FormBuilderField {
        return {
            id: 'logo.height', title: this.translateField('logo.height'), type: 'number', required: false, min: 0, max: 200, unit: 'px',
            setValue: (field, values, value) => set(values, field.id, value ? `${value}px` : 'auto'),
            getValue: (field, values) => {
                const height = get(values, field.id, 'auto').toString();
                return height === 'auto' ? '' : height.replace('px', '');
            },
        };
    }

}
